module.exports = __webpack_public_path__ + "static/img/img_shop_cabinet.30c876d2.png";